import { Button, createTheme, Drawer, Modal } from "@mantine/core";
import buttonClasses from "./Button.module.scss";
import modalClasses from "./Modal.module.scss";
import drawerClasses from "./Drawer.module.scss";

const defaultTheme = createTheme({
  breakpoints: {
    xs: "300px",
  },
  components: {
    Modal: Modal.extend({
      defaultProps: {
        xOffset: -20,
        padding: 15,
        size: "80%",
        centered: true,
        removeScrollProps: {
          allowPinchZoom: true,
        },
      },
      classNames: modalClasses,
    }),
    Drawer: Drawer.extend({
      defaultProps: {
        removeScrollProps: {
          allowPinchZoom: true,
        },
      },
      classNames: drawerClasses,
    }),
    Button: Button.extend({
      classNames: buttonClasses,
    }),
  }
});

export default defaultTheme
